var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60381 8.6039C8.74213 8.74221 8.74213 8.96646 8.60381 9.10477L4.14635 13.5622C3.92324 13.7853 3.54175 13.6273 3.54175 13.3118V4.39687C3.54175 4.08134 3.92324 3.92332 4.14635 4.14644L8.60381 8.6039Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6246 8.6039C14.763 8.74221 14.763 8.96646 14.6246 9.10477L10.1672 13.5622C9.94407 13.7853 9.56258 13.6273 9.56258 13.3118V4.39687C9.56258 4.08134 9.94407 3.92332 10.1672 4.14644L14.6246 8.6039Z",
    fill: "#383838"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextTime);
export default __webpack_public_path__ + "static/media/next_time.4a1fee1fb0b2fc278d6df4faf947eba5.svg";
export { ForwardRef as ReactComponent };